module.exports = __webpack_public_path__ + "static/media/lights-holiday.befcb6f5.svg";